"use client";

import React from "react";

interface ClusterSelectionPanelLayoutProps {
  children: React.ReactNode;
}

const ClusterSelectionPanelLayoutComponent: React.FC<ClusterSelectionPanelLayoutProps> = ({
  children,
}) => {
  return <div className="space-y-6 px-3 py-4">{children}</div>;
};

export const ClusterSelectionPanelLayout = React.memo(ClusterSelectionPanelLayoutComponent);
